import React, { useState, useEffect, useRef } from 'react';
import { Container, Navbar, Nav, NavDropdown } from 'react-bootstrap';
import { Link, useLocation } from 'react-router-dom';
import companies from '../data/companyData';

const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [expanded, setExpanded] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const navbarRef = useRef(null);
  const location = useLocation();

  const companyMenuItems = companies.map((company) => ({
    label: company.name,
    slug: company.slug
  }));

  const getNavClass = (path, exact = false) => {
    // When the Our Companies dropdown is open, suppress active styling on other items
    if (dropdownOpen) {
      return 'nav-link-custom';
    }

    if (location.pathname.startsWith('/company')) {
      if (path === '/company') {
        return 'nav-link-custom active';
      }
      return 'nav-link-custom';
    }

    if (path.includes('#')) {
      const hash = path.split('#')[1];
      const isActive = location.pathname === '/' && location.hash === `#${hash}`;
      return `nav-link-custom${isActive ? ' active' : ''}`;
    }

    const isActive = exact ? location.pathname === path : location.pathname.startsWith(path);
    return `nav-link-custom${isActive ? ' active' : ''}`;
  };

  useEffect(() => {
    const handleScroll = () => {
      const offset = window.scrollY;
      if (offset > 50) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };

    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  // Function to handle menu item click
  const handleNavClick = () => {
    // Close the mobile menu
    setExpanded(false);
    setDropdownOpen(false);
  };

  // Function to handle link click (for external links or different behavior)
  const handleLinkClick = () => {
    setExpanded(false);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => { 
       if (navbarRef.current && !navbarRef.current.contains(event.target)) {
        setExpanded(false);
      }
    };

    if (expanded) {
      document.addEventListener('mousedown', handleClickOutside);  
    }

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, [expanded]);

  return (
    <Navbar
      expand="lg"
      fixed="top"
      expanded={expanded}
      onToggle={(isExpanded) => setExpanded(isExpanded)}
      className={`navbar-custom ${scrolled ? 'scrolled' : ''}`}
      ref={navbarRef}
    >
      <Container>
        <Navbar.Brand as={Link} to="/" onClick={() => handleLinkClick()}>
          <div className="d-flex align-items-center">
            <img
              src="/images/golf-logo.png"
              alt="Golf4International Logo"
              className="navbar-logo"
              style={{
                height: '55px',
                width: 'auto',
                maxWidth: '200px'
              }}
            />

          </div>
        </Navbar.Brand>
        <Navbar.Toggle
          aria-controls="basic-navbar-nav"
          aria-label="Toggle navigation"
        />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="ms-auto align-items-center">
            <Nav.Link
              as={Link}
              to="/"
              className={getNavClass('/', true)}
              onClick={handleNavClick}
            >
              Home
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/services"
              className={getNavClass('/services')}
              onClick={handleNavClick}
            >
              Services
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/tournament"
              className={getNavClass('/tournament')}
              onClick={handleNavClick}
            >
              Tournament
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/academy"
              className={getNavClass('/academy')}
              onClick={handleNavClick}
            >
              Academy
            </Nav.Link>
            <NavDropdown
              title="Our Companies"
              id="our-companies-dropdown"
              className={dropdownOpen ? 'nav-link-custom' : location.pathname.startsWith('/company') ? 'nav-link-custom active' : 'nav-link-custom'}
              menuVariant="light"
              onToggle={(isOpen) => setDropdownOpen(isOpen)}
            >
              {companyMenuItems.map((company) => (
                <NavDropdown.Item
                  as={Link}
                  to={`/company/${company.slug}`}
                  key={company.slug}
                  active={location.pathname === `/company/${company.slug}`}
                  onClick={handleNavClick}
                >
                  {company.label}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
            <Nav.Link
              as={Link}
              to="/about"
              className={getNavClass('/about')}
              onClick={handleNavClick}
            >
              About
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/blog"
              className={getNavClass('/blog')}
              onClick={handleNavClick}
            >
              Articles
            </Nav.Link>
            <Nav.Link
              as={Link}
              to="/contact"
              className={getNavClass('/contact')}
              onClick={handleNavClick}
            >
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};

export default Header;